import React from "react";

const NotificationCountContext = React.createContext();

export default NotificationCountContext;
